import styled from "@emotion/styled"
import { breakPoints, colors } from "../config/theme"
import { Label } from "./Label"
import { Radio } from "./Radio"

const Base = styled.div`
  padding: 0 24px;
  min-height: 72px;
  background-color: ${colors.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  width: 40%;
  min-width: 326px;
  cursor: pointer;
  user-select: none;

  @media only screen and (max-width: ${breakPoints.mobile}) {
    width: 100%;
    min-width: inherit;
  }
`

export const RadioAnswer: React.FC<{
  selected: boolean
  label: string
  onClick?: () => void
}> = ({ selected, label, onClick }) => (
  <Base onClick={onClick}>
    <Radio selected={selected} />
    <Label>{label}</Label>
  </Base>
)
